import { useActiveUser } from '@/containers/App';

export const INTERNAL_USERS_DOMAINS = ['enmon', 'pkv'];

/**
 * Returns true if user email address contains a string from the internal users domains array
 */
export const useIsInternalUser = (): boolean => {
  const user = useActiveUser();

  return Boolean(user && INTERNAL_USERS_DOMAINS.some(domain => user.email.toLocaleLowerCase().includes(domain)));
};
